import classNames from 'classnames';
import React from 'react';

import AashayCommitsEntry from './AashayCommitsEntry';
import BasicMilestoneEntry from './BasicMilestoneEntry';
import EmailThreadEntry from './EmailThreadEntry';
import EmojiEntry from './EmojiEntry';
import LockedEntry from './LockedEntry';
import SummaryEntry from './SummaryEntry';
import MarkdownText from '../MarkdownText';
import milestones from '../../data/milestones';
import codeStats from '../../data/code-stats';

import './Timeline.css';

const EntryTypeMap = {
  aashayCommits: AashayCommitsEntry,
  summary: SummaryEntry,
  email: EmailThreadEntry,
  emoji: EmojiEntry,
  locked: LockedEntry,
};

const TimelineEntry = ({ type, data, includeDate, year }) => {
  const Entry = EntryTypeMap[type] || BasicMilestoneEntry;

  return (
    <li className="Timeline__entry">
      <div className={classNames('Timeline__entry-icon', {
        [`Timeline__entry-icon--${type}`]: !!type,
      })} />
      <div className="TimelineEntry__entry-content">
        {includeDate && (
          <a
            className="TimelineEntry__entry-date"
            href={`#${data.id}`}
            id={data.id}
          >
            {data.date}
          </a>
        )}
        {data.title && (
          <h3 className="TimelineEntry__header">
            <MarkdownText text={data.title} inlineOnly />
          </h3>
        )}
        <Entry year={year} {...data} />
      </div>
    </li>
  );
};

export default ({ year, summary }) => (
  <ol className="Timeline">
    {milestones[year].map((milestone, index) => (
      <TimelineEntry
        key={index}
        data={milestone}
        type={milestone.type}
        includeDate
      />
    ))}
    <TimelineEntry
      type="summary"
      year={year}
      data={{
        title: `${year} In Review`,
        stats: codeStats[year],
        summary,
      }}
    />
  </ol>
);


// WEBPACK FOOTER //
// ./src/components/timeline/Timeline.js